<template>
  <app-header-dropdown right no-caret>
    <template slot="header">
      <i class="icon-flag"></i>
      <b-badge pill variant="info">{{langCount}}</b-badge>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="dropdown-menu-lg text-center">
        <strong>{{langCount}} available languages</strong>
      </b-dropdown-header>
      <b-dropdown-item>
        <i class="icon-check text-success"></i> English
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="icon-check text-danger"></i> Chinese
      </b-dropdown-item>
    </template>
  </app-header-dropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
export default {
  name: 'DefaultHeaderDropdownNotif',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { langCount: 2 };
  }
};
</script>
